import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("StringListTerminal", "StringCompareTerminal", {

    type: function() {
      return 'StringList';
    },

    possibleValues: function(terminalName) {
      var data = app.TerminalMetaData[terminalName || this.get('terminal')];
      if (data) {
        if (typeof data.possibleValues === 'function') {
          return data.possibleValues(app.config.features);
        } else {
          return data.possibleValues;
        }
      } else {
        return [];
      }
    }
  });
});
